<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="448"
    @click:outside="onClickOutsideNewMessage"
    @keydown="onKeydownNewMessage"
    content-class="new-schedule-message-dialog"
  >
    <v-card elevation="0">
      <v-form ref="form" class="new-schedule-message-form">
        <div class="new-schedule-message-form-body">
          <v-toolbar flat height="76">
            <v-toolbar-title class="new-schedule-message-toolbar-title"
              >New message</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn color="accent" icon tile @click="closeScheduleMessageDialog">
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container class="new-schedule-message-card-container">
            <dialog-input
              label="Message"
              name="message"
              :textarea="true"
              :textareaExpandable="true"
              :value="newMessageData.message || ''"
              @input="onInput"
            />
          </v-container>
          <v-container class="new-schedule-message-card-container pt-0">
            <!-- commented because of new time picker -->
            <!-- <dialog-time-picker
              label="Time"
              name="time"
              :value="newMessageData.time"
              :initial-time="newMessageData.time"
              @input="onInput"
            /> -->
            <time-picker
              @input="onInput"
              :initial-time="newMessageData.time"
              :is-submit="messageScheduled"
            />
          </v-container>
          <v-container class="new-schedule-message-card-container">
            <v-row align="center">
              <v-col sm="6">
                <span>Media choosen</span>
                <div
                  class="new-schedule-message-file-details"
                  v-if="scheduleMessageResource"
                >
                  <img
                    v-if="scheduleMessageResource.thumbnailUrl"
                    :src="scheduleMessageResource.thumbnailUrl"
                    @click="openBigImage"
                  />
                  <v-progress-circular
                    v-else
                    color="accent"
                    indeterminate
                    size="40"
                  />
                  <span>{{ scheduleMessageResource.title }}</span>
                </div>
              </v-col>
              <v-col sm="6">
                <dialog-date-picker
                  label="Choose date"
                  name="date"
                  :value="newMessageData.date"
                  :initial-date="newMessageData.date"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-schedule-message-card-container py-0">
            <dialog-checkbox
              label="Acknowledgement required?"
              name="acknowledge"
              :value="newMessageData.acknowledge"
              :option="{ label: 'Yes', value: newMessageData.acknowledge }"
              @input="onInput"
            />
          </v-container>
          <v-container class="new-schedule-message-card-container">
            <dialog-input
              label="ResourceId"
              name="resourceId"
              readonly
              :value="newMessageData.resourceId || 0"
              hidden
              @input="onInput"
            />
          </v-container>
        </div>
        <v-container
          class="new-schedule-message-card-footer d-flex justify-end"
        >
          <v-btn
            :disabled="!formIsValidCheck"
            rounded
            color="primary"
            elevation="0"
            @click="openChooseParticipantDialog"
          >
            Choose Participants
          </v-btn>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogCheckbox from '@/components/forms/DialogCheckbox.vue'
import DialogDatePicker from '@/components/forms/DialogDatePicker.vue'
import DialogInput from '@/components/forms/DialogInput.vue'
// import DialogTimePicker from '@/components/forms/DialogTimePicker.vue'
import TimePicker from '@/components/forms/TimePicker.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ScheduleMessageDialog',
  components: {
    DialogInput,
    DialogCheckbox,
    // DialogTimePicker,
    DialogDatePicker,
    TimePicker,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    messageScheduled: {
      type: Boolean,
      default: false,
    },
    scheduleMessageResource: {
      type: Object,
      default: null,
    },
    newMessageData: {
      type: Object,
      default: () => {
        return {
          message: '',
          date: this.$moment().format('YYYY-MM-DD'),
          time: '06:00',
          resourceId: null,
          acknowledge: false,
          participants: [],
        }
      },
    },
  },
  data() {
    return {
      dialog: false,
      formIsValidCheck: false,
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      }
      this.formIsValidCheck = false
    },
    messageScheduled: function(val) {
      if (val) {
        this.dialog = false
        this.formIsValidCheck = false
      }
    },
  },
  computed: {
    ...mapState('patientsStates', ['currentPatient']),
  },
  methods: {
    formIsValid() {
      if (
        this.newMessageData.message &&
        this.newMessageData.message.trim() != '' &&
        this.newMessageData.time &&
        this.newMessageData.date &&
        this.$moment(
          this.newMessageData.date + ' ' + this.newMessageData.time,
        ).isSameOrAfter(this.$moment(this.getParticipantTime()), 'day')
      )
        this.formIsValidCheck = true
      else this.formIsValidCheck = false
    },
    onInput({ name, value }) {
      this.newMessageData[name] = value
      this.formIsValid()
    },
    openScheduleMessageDialog(id, files) {
      this.$emit('open-schedule-message-dialog', id, files)
      this.dialog = true
    },
    openChooseParticipantDialog() {
      this.$emit('open-choose-participant-dialog')
    },
    async openBigImage() {
      let type = 1
      switch (this.scheduleMessageResource.fileTypeId) {
        case 18:
          type = 1
          break
        case 19:
          type = 3
          break
        default:
          type = 1
          break
      }
      const title =
        this.scheduleMessageResource.title.replace(/[/\\?%*:|"<>]/g, '-') +
        '.' +
        this.scheduleMessageResource.name
          .split('.')
          .pop()
          .trim()
          .toLowerCase()
      this.$emit('show-bigger-image', {
        url: this.scheduleMessageResource.fileUrl,
        name: title,
        file: this.scheduleMessageResource.previewUrl,
        mlResourceUrl: this.scheduleMessageResource.id,
        type: type,
      })
    },
    closeScheduleMessageDialog() {
      this.dialog = false
      this.formIsValidCheck = false
      this.$emit('close-schedule-message-dialog')
    },
    closeDialog() {
      this.dialog = false
      this.formIsValidCheck = false
      this.$emit('close-schedule-message-dialog')
    },
    onClickOutsideNewMessage() {
      this.closeDialog()
    },
    onKeydownNewMessage(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
    getParticipantTime() {
      const currentTime = new Date().getTime()
      const currentDateFormat = this.$moment(currentTime).format(
        'YYYY-MM-DD HH:mm:ss',
      )
      const patientDateFormat = this.$moment(currentTime)
        .tz(this.currentPatient.tz || 'Europe/Warsaw')
        .format('YYYY-MM-DD HH:mm:ss')
      const calculateDiff = this.$moment(patientDateFormat).diff(
        this.$moment(currentDateFormat),
      )

      return new Date(currentTime + calculateDiff).getTime()
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';
.new-schedule-message {
  &-dialog {
    height: 500px;
    max-height: calc(100% - #{2 * $gutter}) !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
    }
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-container {
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-footer {
      padding: 1.5 * $gutter;
    }
  }
  &-file-details {
    display: inline-block;
    img {
      width: 40px;
      height: 40px;
      display: inline-block;
      vertical-align: middle;
      object-fit: cover;
      margin-left: 10px;
      cursor: pointer;
    }
    .v-progress-circular {
      margin-left: 10px;
    }
    span {
      cursor: default;
      margin-left: 5px;
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5 * $gutter;
        padding-right: 1.5 * $gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25 * $gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25 * $gutter;
    }
  }
}
</style>
